// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login_content .login_btn {\n  width: 100%;\n}\n.login_content .toReg {\n  font-size: 0.072917rem;\n}\n.login_content .el-tabs__header {\n  margin: 0 0 0.229167rem;\n}\n.login_content .el-form-item {\n  margin-bottom: 0.15625rem;\n}", ""]);
// Exports
module.exports = exports;
